import { apiClient } from "./api-client";

class AuthService {
	async forgotPassword(email: string): Promise<{ message: string }> {
		const response = await apiClient.post<{ message: string }>("/forgot-password", {
			email,
		});
		return response.data;
	}

	async resetPassword(data: {
		token: string;
		email: string;
		password: string;
		password_confirmation: string;
	}): Promise<{ message: string }> {
		const response = await apiClient.post<{ message: string }>("/reset-password", data);
		return response.data;
	}
}

export const authService = new AuthService();
